function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Tooltip from './Tooltip';
import Icon from './Icon';
import './PageIdentity.css';

var PageIdentity = function (_Component) {
    _inherits(PageIdentity, _Component);

    function PageIdentity(props) {
        _classCallCheck(this, PageIdentity);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.handlePageIdentityClick = function (e) {
            e.stopPropagation();
            _this.setState({
                displayPageIdentityTooltip: !_this.state.displayPageIdentityTooltip
            });
        };

        _this.handlePageIdentityDismiss = function () {
            _this.setState({
                displayPageIdentityTooltip: false
            });
        };

        _this.state = {
            displayPageIdentityTooltip: false
        };
        return _this;
    }

    PageIdentity.prototype.componentDidMount = function componentDidMount() {
        document.body.addEventListener('click', this.handlePageIdentityDismiss);
    };

    PageIdentity.prototype.componentWillUnmount = function componentWillUnmount() {
        document.body.removeEventListener('click', this.handlePageIdentityDismiss);
    };

    PageIdentity.prototype.isSecure = function isSecure() {
        return this.props.appPage;
    };

    PageIdentity.prototype.getIcon = function getIcon() {
        if (this.isSecure()) {
            return React.createElement(Icon, { name: 'lock-alt', fill: true });
        }
        return '';
    };

    PageIdentity.prototype.getTrustLevel = function getTrustLevel() {
        if (this.props.appPage) {
            return 'Epi App';
        }
        return '';
    };

    PageIdentity.prototype.getTrustDescription = function getTrustDescription() {
        if (this.props.appPage) {
            return 'This is a secure Epi application page, only available in the app.';
        }
    };

    PageIdentity.prototype.render = function render() {
        return React.createElement(
            'div',
            { className: 'PageIdentity', 'data-secure': this.isSecure() },
            React.createElement(
                'div',
                { className: 'PageIdentity-location', onClick: this.handlePageIdentityClick },
                React.createElement(
                    'span',
                    { className: 'PageIdentity-icon' },
                    this.getIcon()
                ),
                React.createElement(
                    'span',
                    { className: 'PageIdentity-ari' },
                    this.props.ari
                )
            ),
            React.createElement(
                Tooltip,
                { width: '300px', active: this.state.displayPageIdentityTooltip },
                React.createElement(
                    'div',
                    { className: 'Tooltip-title' },
                    React.createElement(
                        'span',
                        { className: 'Tooltip-title-icon' },
                        this.getIcon()
                    ),
                    React.createElement(
                        'span',
                        { className: 'Tooltip-title-content' },
                        this.getTrustLevel()
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'Tooltip-content' },
                    this.getTrustDescription()
                )
            )
        );
    };

    return PageIdentity;
}(Component);

export default PageIdentity;